"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createCheckInEnvelope = createCheckInEnvelope;

var _dsn = require("./utils-hoist/dsn.js");

var _envelope = require("./utils-hoist/envelope.js");

var _object = require("./utils-hoist/object.js");

/**
 * Create envelope from check in item.
 */
function createCheckInEnvelope(checkIn, dynamicSamplingContext, metadata, tunnel, dsn) {
  const headers = {
    sent_at: new Date().toISOString()
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }

  if (!!tunnel && !!dsn) {
    headers.dsn = (0, _dsn.dsnToString)(dsn);
  }

  if (dynamicSamplingContext) {
    headers.trace = (0, _object.dropUndefinedKeys)(dynamicSamplingContext);
  }

  const item = createCheckInEnvelopeItem(checkIn);
  return (0, _envelope.createEnvelope)(headers, [item]);
}

function createCheckInEnvelopeItem(checkIn) {
  const checkInHeaders = {
    type: 'check_in'
  };
  return [checkInHeaders, checkIn];
}